<template>
    <div class="rectify-examine-dialog">
        <el-dialog
            title="申诉"
            :visible.sync="isExamineDialog"
            width="550px"
            :before-close="closeDialog"
        >
            <el-form ref="form" :model="form" :rules="rules" size="mini" style="font-size: 14px;">
                <el-form-item prop="examineReason">
                    <el-input
                        type="textarea"
                        placeholder="在此输入申诉原因"
                        :rows="5"
                        v-model="form.examineReason"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="upload-enclosure">
                <div class="title">证明文件</div>
                <div class="upload_enclosure_top">
                    <Upload :text="'上传'" :uploadDisplayType="'iconAndText'" @uploadSuccess="uploadSuccess"></Upload>
                </div>
            </div>
            <el-table :data="fileTableData" border height="150" style="width: 100%">
                <el-table-column label="附件名称" prop="fileName" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <span>
                            <el-button size="mini" type="text" @click="actionFn(scope.row, '1')">预览</el-button>
                        </span>
                        <span class="span-button">
                            <el-button size="mini" type="text" @click="actionFn(scope.row, '2')">下载</el-button>
                        </span>
                        <span class="span-button">
                            <el-button size="mini" type="text" @click="actionFn(scope.row, '3')">删除</el-button>
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <div class="tab-box">
                <div class="title m-top-t">操作历史记录</div>
                <el-table :data="performanceExamineDerates" style="width: 100%" border tooltip-effect='dark'>
                    <el-table-column prop="derateStatusText" label="操作" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="createUserCode" label="操作人" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="操作时间" width="200" align="center">
                    </el-table-column>
                    <el-table-column prop="examineReason" label="意见" width="200" align="center">
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import Upload from '../../components/upload/Index.vue';
import {
    customerDailyAssessmentsAppeal, mobileExamineDerates
} from '../../../lsrm/api/achievements/daylyAssessment.js';
import { mapGetters } from 'vuex';
import { filePreview } from '@/utils/filePreview.js';
export default {
    components: { Upload },
    props: {
        isExamineDialog: {
            type: Boolean,
            default: function() {
                return false;
            }
        },
        examrow: {
            type: Object,
            default: function() {
                return {};
            }
        },
        selectItem: {
            type: Array,
            default: function() {
                return [];
            }
        },
        dictData: {
            default: function() {
                return {};
            }
        }
    },
    data() {
        return {
            performanceExamineDerates: [],
            fileTableData: [],
            form: {
                examineReason: '',
                rejectDirection: ''
            },
            rules: {
                examineReason: {
                    required: true,
                    message: '请输入申诉原因',
                    trigger: 'change'
                }
            }
        };
    },
    mounted() {
        mobileExamineDerates({ derateCode: this.examrow.derateCode }).then(res => {
            if (res && +res.code === 0) {
                this.form.rejectDirection = res.data.rejectDirection;
                this.form.examineReason = res.data.examineReason;
                this.fileTableData = res.data.moduleFile;
                this.performanceExamineDerates = res.data.performanceExamineDerates;
                this.conversionData(this.performanceExamineDerates);
            }
        });
    },
    methods: {
        uploadSuccess(res) {
            this.fileTableData.push({
                fileName: res.data.data.localFileName,
                fileUrl: res.data.data.downUrl.replace('https', 'http'),
                fileId: res.data.data.id
            });
        },
        conversionData(list) {
            list.forEach(el => {
                el.derateStatusText = this.dictData.SRM_PERFOR_OPERATE_TYPE[el.derateStatus];
                el.examineReason = el.examineType === '1' ? el.examineReason : el.derateStatus === '0' ? el.examineReason : el.rejectDirection;
            });
        },
        closeDialog() {
            this.$emit('update:isExamineDialog', false);
            this.$emit('reload');
        },
        selectItemArr(moduleFileDtos) {
            return this.selectItem.map(el => {
                return {
                    examineId: el.examineId,
                    examineReason: this.form.examineReason,
                    dailyStatus: el.dailyStatus,
                    derateCode: el.derateCode,
                    moduleFileDtos
                };
            });
        },
        customerDailyAssessmentsAppealFunc(moduleFileDtos) {
            let parlist = [];
            if (this.selectItem.length) {
                parlist = this.selectItemArr(moduleFileDtos);
            } else {
                parlist.push({
                    examineId: this.examrow.examineId,
                    examineReason: this.form.examineReason,
                    dailyStatus: this.examrow.dailyStatus,
                    derateCode: this.examrow.derateCode,
                    moduleFileDtos
                });
            }
            customerDailyAssessmentsAppeal(parlist).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('申诉成功！');
                    this.$emit('update:isExamineDialog', false);
                    this.$emit('reload');
                }
            });
        },
        confirm() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    if (this.fileTableData.length === 0) {
                        this.$message.warning('请上传附件！');
                        return;
                    }
                    const moduleFileDtos = this.fileTableData.map(el => {
                        return {
                            fileName: el.fileName,
                            fileUrl: el.fileUrl,
                            fileId: el.fileId
                        };
                    });
                    this.customerDailyAssessmentsAppealFunc(moduleFileDtos);
                } else {
                    this.$message.warning('请输入完整！');
                }
            });
        },
        actionFn(row, type, index) {
            if (type === '2') {
                window.open(row.fileUrl, '_parent');
            } else if (type === '1') {
                filePreview(row);
            } else {
                this.fileTableData.splice(index, 1);
            }
        }
    },
    computed: {
        ...mapGetters(['currentTenant', 'applicationCode', 'tenantCode'])
    }
};
</script>
<style lang="less">
.rectify-examine-dialog {
    .tab-box {
        margin-top:10px;width: 100%;
    }
    .examine-table-title {
        font-size: 14px;
        color: #333333;
    }
    .upload-enclosure {
        width:100%;
        display: flex;
        justify-content: space-between;
        margin: 10px 0
    }
    .title {
        font-size: 14px;
    }
    .upload_enclosure_top {
        color: #00BCBF;
        cursor: pointer;
        display: flex;
        align-items: center;
    }
    .span-button {
        margin-left: 10px;
    }
    .m-top-t {
        margin: 20px 0 10px;
    }
}
</style>